import Avatar from "./Avatar";
import "./Rangliste.css";

/**
 * Rangliste (Jahres-Runde, Endstand, Punkte-Tabelle).
 * eintraege: [{ key, name, platz, wert, unterzeile, sieg, ich, plus }]
 * @category spiel
 */
export function Rangliste({ eintraege, farbe, leerText = "Niemand dabei." }) {
  if (!eintraege.length) return <p className="hinweis-text">{leerText}</p>;
  return (
    <ol className="rangliste">
      {eintraege.map((e) => (
        <li key={e.key} className={`rang${e.sieg ? " sieg" : ""}`}>
          <span className="rang-platz">{e.platz ?? "–"}</span>
          <Avatar name={e.name} farbe={farbe(e.name)} />
          <span className="rang-name">
            <span className="rang-name-zeile">
              {e.name}
              {e.ich && <em className="du-marke">Du</em>}
            </span>
            {e.unterzeile && <small>{e.unterzeile}</small>}
          </span>
          <span className={`rang-wert${e.wert === null || e.wert === undefined ? " leer" : ""}`}>{e.wert ?? "––––"}</span>
          {e.plus && <span className="rang-plus">+{e.plus}</span>}
        </li>
      ))}
    </ol>
  );
}

export default Rangliste;
